import React from 'react';
import { GetColab } from '../../modules/Colab/types';
import { useColabContext } from './ColabContext';
import { recordStatuses } from './colabOptions';

type ColabDetailsProps = { colabEntity: GetColab; compact?: boolean };

const colabStatusCell: React.FC<ColabDetailsProps> = ({ colabEntity, compact = false }) => {
  const { data, updateStatus } = useColabContext();
  const record = data.find(e => e.partitionKey === colabEntity.partitionKey && e.rowKey === colabEntity.rowKey);
  if (!record) return null;

  const handleStatusDropdownChange = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    try {
      const value = event.target.value;
      updateStatus(colabEntity.partitionKey, colabEntity.rowKey, value);
    } catch (error) {
      console.error('Error updating colab record status on dropdown change:', error);
    }
  };

  return (
    <div>
      <select
        id={colabEntity.rowKey}
        className={`${
          compact ? 'colab-table-select colab-table-select--status' : 'colab-drawer-select'
        } colab-field-control max-w-full`}
        value={record?.status || 'New'}
        onChange={handleStatusDropdownChange}>
        {recordStatuses.map(({ id, label, value }) => (
          <option key={id} value={value}>
            {label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default colabStatusCell;
